import { Component, OnInit } from '@angular/core';
import { UserService } from '@apply4u/services/user.service';
import { AuthService } from '@apply4u/services/auth-services/auth.service';
import { ActivatedRoute } from '@angular/router';
import { ContextService } from '@apply4u/services/context-service';
import { IsNotNull } from '@apply4u/shared/helpers/common/type-safe-helpers';

@Component({
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  standalone:true
})
export class LoginComponent implements OnInit {

  userId: number;
  constructor(private authService: AuthService,
    private routeParamService: ActivatedRoute,
    private contextService: ContextService,
    private userService: UserService) {
  }

  ngOnInit(): void {
    if (this.contextService.IsBrowser) {    
      this.authService.PostSignOutSettings(false);
      this.contextService.SetupDefaults();
      this.routeParamService.queryParamMap.subscribe(params => {
        if (params.has("shouldsignin")) {
          let jobId = 0;

          if (params.has("jobid")) {
            jobId = parseInt(params.get("jobid"));
          }

          this.authService.SignInRedirect(jobId, this.contextService.IsJobSeeker);
        } else {
          this.SignInRedirectCallback();
        }
      });
    }
  }

  SignInRedirectCallback(): void {
    if (this.contextService.IsBrowser) {
        this.authService.SignInRedirectCallback().then(() => {
            this.userService.LoadUserProfile(this.authService.user.profile.email);
            if (IsNotNull(this.authService.user.profile['id'])) {
                const userId = Number(this.authService.user.profile['id']);
                this.userId = userId;
                this.userService.UpdateLastLogin(userId).subscribe();
            }
        });
    }
}

}
